import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NotificationGuideComponent } from './components/notification-guide/notification-guide.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';

@NgModule({
  declarations: [NotificationGuideComponent],
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
  ],
})
export class CoreModule { }
